import React, { useEffect, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid'

interface Idea {
    id: number;
    nombre_completo: string;
    telefono_correo: string;
    area_departamento: string;
    cdo: string;
    nombre_iniciativa: string;
    descripcion: string;
    aporte: string;
    desea_participar: string;
    estado: string;
    fecha_creacion: string;
}
    const formatearFecha = (fecha: string) => {
      const d = new Date(fecha);
      return `${String(d.getDate()).padStart(2,'0')}/${String(d.getMonth()+1).padStart(2,'0')}/${d.getFullYear()}`;
    };

const IdeasList: React.FC = () => {
    const [ideas, setIdeas] = useState<Idea[]>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [estadoSeleccionado, setEstadoSeleccionado] = useState<{ [id: number]: string }>({});
    const [showModal, setShowModal] = useState(true);
    const [passwordInput, setPasswordInput] = useState("");
    const [passwordError, setPasswordError] = useState(false);
    const [loading, setLoading] = useState(false);

    const PASSWORD = "brame2024";

    useEffect(() => {
        const accesoPermitido = localStorage.getItem('acceso_nubeteca');
        if (accesoPermitido === 'true') {
            setShowModal(false);
        }
    }, []);

    useEffect(() => {
        if (!showModal) {
            setLoading(true);
            fetch('https://apis.grupobrame.com/api/get_ideas')
                .then(res => res.json())
                .then(data => {
                    if (data.success) {
                        setIdeas(data.ideas);
                    } else {
                        alert("Error al cargar las ideas.");
                    }
                })
                .catch(err => {
                    console.error(err);
                    alert("Error de red.");
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [showModal]);

    const handlePasswordSubmit = () => {
        if (passwordInput === PASSWORD) {
            localStorage.setItem('acceso_nubeteca', 'true');
            setShowModal(false);
            setPasswordError(false);
        } else {
            setPasswordError(true);
            setTimeout(() => {
                window.location.href = "https://www.grupobrame.com";
            }, 1400);
        }
    };

    const totalPages = Math.ceil(ideas.length / itemsPerPage);
    const start = (currentPage - 1) * itemsPerPage;
    const paginatedIdeas = ideas.slice(start, start + itemsPerPage);

    const cambiarPagina = (pagina: number) => {
        if (pagina >= 1 && pagina <= totalPages) {
            setCurrentPage(pagina);
        }
    };

    const actualizarEstado = (id: number) => {
        const estado = estadoSeleccionado[id];
        if (!estado) {
            alert("Selecciona un estado primero.");
            return;
        }

        fetch('https://apis.grupobrame.com/api/update_estado', {
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id, estado }),
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.success) {
                    setIdeas((prevIdeas) =>
                        prevIdeas.map((idea) =>
                            idea.id === id ? { ...idea, estado } : idea
                        )
                    );
                    alert('Estado actualizado correctamente');
                } else {
                    alert('Error al actualizar estado');
                }
            })
            .catch((err) => {
                console.error(err);
                alert('Error de red');
            });
    };

    // Descargar Excel de todas las ideas
    const descargarExcel = async () => {
      try {
        const res = await fetch("https://apis.grupobrame.com/api/get_ideas");
        const data = await res.json();

        if (data.success) {
          const ideas = data.ideas;
          if (!ideas || ideas.length === 0) {
            alert("No hay ideas para descargar");
            return;
          }
          // Usar los headers en el mismo orden y nombres que el backend retorna (del primer objeto de data.ideas)
          const headers = ["id", "nombre_completo","telefono_correo",  "area_departamento", "cdo", "nombre_iniciativa", "descripcion", "aporte", "desea_participar", "fecha_creacion", "estado"];
          /*const headers = Object.keys(data.ideas[0]);*/
          // Generar filas con fecha formateada y codificación correcta
          const rows = ideas.map((idea: any) => {
            // Copiar el objeto para no modificar el original
            const ideaCopia = { ...idea };
            if (ideaCopia.fecha_creacion) {
              ideaCopia.fecha_creacion = formatearFecha(ideaCopia.fecha_creacion);
            }
            // Para cada header, tomar el valor en ese orden exacto
            return headers.map((key) => {
              let val = ideaCopia[key];
              if (val === null || val === undefined) val = '';
              // Escapar comillas dobles en el valor y envolver en comillas si contiene coma, salto de línea o comillas
              const strVal = String(val).replace(/"/g, '""');
              if (/[",\n]/.test(strVal)) {
                return `"${strVal}"`;
              }
              return strVal;
            }).join(",");
          }).join("\n");
          const csv = headers.join(",") + "\n" + rows;
          const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
          const url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "ideas.csv";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        } else {
          alert("No se pudieron obtener las ideas");
        }
      } catch (err) {
        console.error(err);
        alert("Error al generar el Excel");
      }
    };

    return (
        <div className="max-w-7xl mx-auto p-4 py-12 ">
            {showModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded shadow-md max-w-sm w-full">
                        <h2 className="text-lg font-bold mb-4">Ingresa la contraseña</h2>
                        <input
                            type="password"
                            className="w-full border px-3 py-2 rounded mb-3"
                            value={passwordInput}
                            onChange={(e) => setPasswordInput(e.target.value)}
                            placeholder="Contraseña"
                        />
                        {passwordError && (
                            <p className="text-red-500 text-sm mb-3">Contraseña incorrecta. Redirigiendo...</p>
                        )}
                        <button
                            onClick={handlePasswordSubmit}
                            className="bg-orange-600 text-white px-4 py-2 rounded w-full"
                        >
                            Entrar
                        </button>
                    </div>
                </div>
            )}

            {loading ? (
                <div className="flex flex-col justify-center items-center h-64">
                    <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-orange-500"></div>
                    <p className="mt-4 text-gray-700 text-sm">Cargando ideas...</p>
                </div>
            ) : (
                <div>
                    <div className="px-4 sm:px-6 lg:px-8 min-h-120">

                            <div className="flex justify-between items-center w-full">
                                <div>
                                    <h1 className="font-semibold text-gray-900 text-4xl font-bold">Nubeteca Creativa</h1>
                                </div>
                                <div className="ml-auto">
                                    <button
                                      onClick={descargarExcel}
                                      className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded"
                                    >
                                      Descargar Excel
                                    </button>
                                </div>
                            </div>

                        <div className="mt-8 flow-root">
                            <div className="-mx-4 -my-2 overflow-x-scroll sm:-mx-6 lg:-mx-8">
                                <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                                    <table className="min-w-full divide-y divide-gray-300 table-auto">
                                        <thead className="bg-gray-100">
                                        <tr>
                                            <th scope="col" className="py-3.5 pr-3 pl-4 text-left text-base font-bold text-gray-900 sm:pl-3">Nombre</th>
                                            <th scope="col" className="py-3.5 pr-3 pl-4 text-left text-base font-bold text-gray-900 sm:pl-3">Correo ó Teléfono</th>
                                            <th scope="col" className="py-3.5 pr-3 pl-4 text-left text-base font-bold text-gray-900 sm:pl-3">Área</th>
                                            <th scope="col" className="py-3.5 pr-3 pl-4 text-left text-base font-bold text-gray-900 sm:pl-3">CDO</th>
                                            <th scope="col" className="py-3.5 pr-3 pl-4 text-left text-base font-bold text-gray-900 sm:pl-3">Nombre de Iniciativa</th>
                                            <th scope="col" className="py-3.5 pr-3 pl-4 text-left text-base font-bold text-gray-900 sm:pl-3">Descripción</th>
                                            <th scope="col" className="py-3.5 pr-3 pl-4 text-left text-base font-bold text-gray-900 sm:pl-3">Aporte</th>
                                            <th scope="col" className="py-3.5 pr-3 pl-4 text-left text-base font-bold text-gray-900 sm:pl-3">Participa?</th>
                                            <th scope="col" className="py-3.5 pr-3 pl-4 text-left text-base font-bold text-gray-900 sm:pl-3">Fecha creación</th>
                                            <th scope="col" className="py-3.5 pr-3 pl-4 text-left text-base font-bold text-gray-900 sm:pl-3">Estado</th>
                                            <th scope="col" className="py-3.5 pr-3 pl-4 text-left text-base font-bold text-gray-900 sm:pl-3"></th>
                                        </tr>
                                        </thead>
                                        <tbody className="bg-white">
                                        {paginatedIdeas.map((idea) => {
                                            const fechaFormateada = idea.fecha_creacion ? formatearFecha(idea.fecha_creacion) : "";
                                            return (
                                            <tr key={idea.id} className="odd:bg-white even:bg-gray-50">
                                                <td className="px-3 py-4 text-sm whitespace-nowrap text-gray-900 font-semibold">{idea.nombre_completo}</td>
                                                <td className="px-3 py-4 text-sm whitespace-nowrap text-gray-900">{idea.telefono_correo}</td>
                                                <td className="px-3 py-4 text-sm whitespace-nowrap text-gray-500">{idea.area_departamento}</td>
                                                <td className="px-3 py-4 text-sm whitespace-nowrap text-gray-500">{idea.cdo}</td>
                                                <td className="px-3 py-4 text-sm whitespace-nowrap text-gray-800 font-semibold">{idea.nombre_iniciativa}</td>
                                                <td className="px-3 py-4 text-sm/6 text-gray-500 whitespace-normal break-words min-w-150">
                                                    {idea.descripcion}
                                                </td>
                                                <td className="px-3 py-4 text-sm/6 text-gray-500 whitespace-normal break-words min-w-150">{idea.aporte}</td>
                                                <td className="px-3 py-4 text-sm whitespace-nowrap text-gray-500">{idea.desea_participar}</td>
                                                <td className="px-3 py-4 text-sm whitespace-nowrap text-gray-500">
                                                    {fechaFormateada}
                                                </td>
                                                {/* Columna ESTADO */}
                                                <td className="px-3 py-4 text-sm text-gray-500 whitespace-nowrap">
                                                    <select
                                                        value={estadoSeleccionado[idea.id] ?? idea.estado ?? ""}
                                                        onChange={(e) =>
                                                            setEstadoSeleccionado((prev) => ({
                                                                ...prev,
                                                                [idea.id]: e.target.value,
                                                            }))
                                                        }
                                                        className="border border-gray-300 rounded px-2 py-1 text-sm"
                                                    >
                                                        <option value="">Pendiente</option>
                                                        <option value="en revisión">En revisión</option>
                                                        <option value="aprobada">Aprobada</option>
                                                        <option value="rechazada">Rechazada</option>
                                                    </select>
                                                </td>
                                                {/* Columna ACCIÓN */}
                                                <td className="px-3 py-4 text-sm text-gray-500 whitespace-nowrap">
                                                    <button
                                                        onClick={() => actualizarEstado(idea.id)}
                                                        className="bg-[#D75313] hover:bg-orange-700 text-white px-3 py-1 rounded text-sm"
                                                    >
                                                        Guardar
                                                    </button>
                                                </td>
                                            </tr>
                                            );
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Paginación */}
                    <div className="flex items-center justify-between bg-white px-4 py-3 sm:px-6 mt-4">
                        <div className="flex flex-1 justify-between sm:hidden">
                            <button
                                onClick={() => cambiarPagina(currentPage - 1)}
                                disabled={currentPage === 1}
                                className="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50"
                            >
                                Anterior
                            </button>
                            <button
                                onClick={() => cambiarPagina(currentPage + 1)}
                                disabled={currentPage === totalPages}
                                className="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50"
                            >
                                Siguiente
                            </button>
                        </div>
                        <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
                            <div>
                                <p className="text-sm text-gray-700">
                                    Mostrando <span className="font-medium">{currentPage === 1 ? 1 :(currentPage-1)*10 +1}</span> de <span className="font-medium">{(currentPage)*10 > ideas.length ? ideas.length : (currentPage)*10 }</span> of {ideas.length }
                                    <span className="font-medium"></span> resultados.
                                </p>
                            </div>
                            <div>
                                <nav aria-label="Pagination" className="isolate inline-flex -space-x-px rounded-md shadow-xs">
                                    <button
                                        onClick={() => cambiarPagina(currentPage - 1)}
                                        disabled={currentPage === 1}
                                        className="relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-gray-300 ring-inset hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
                                    >
                                        <span className="sr-only">Previous</span>
                                        <ChevronLeftIcon aria-hidden="true" className="size-5" />
                                    </button>
                                    {/* Current: "z-10 bg-indigo-600 text-white focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600", Default: "text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:outline-offset-0" */}
                                    {Array.from({ length: totalPages }).map((_, i) => (
                                        <button
                                            key={i + 1}
                                            onClick={() => cambiarPagina(i + 1)}
                                            className={`px-3 py-1 rounded ${
                                                currentPage === i + 1
                                                    ? 'relative z-10 inline-flex items-center bg-[#D35400] px-4 py-2 text-sm font-semibold text-white focus:z-20 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
                                                    : 'relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-gray-300 ring-inset hover:bg-gray-50 focus:z-20 focus:outline-offset-0'
                                            }`}
                                        >
                                            {i + 1}
                                        </button>
                                    ))}
                                    <button
                                        onClick={() => cambiarPagina(currentPage + 1)}
                                        disabled={currentPage === totalPages}
                                        className="relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-gray-300 ring-inset hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
                                    >
                                        <span className="sr-only">Next</span>
                                        <ChevronRightIcon aria-hidden="true" className="size-5" />
                                    </button>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default IdeasList;